<template>
  <div>
    <modal-form v-model="show" :submit="submit" size="lg">
      <template v-slot:title>{{ ID ? "Editar" : "Novo" }} TalkTelecom</template>
      <template v-slot:body>
        <v-row>
          <v-col cols="4">
            <input-text label="Url Base" v-model="model.urlBase" />
          </v-col>
          <v-col cols="4">
            <input-text label="Método" v-model="model.metodo" />
          </v-col>
          <v-col cols="4">
            <input-text
              label="Codigo Integração"
              v-model="model.codigoIntegracao"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <input-date label="Data Inicio" v-model="model.dataInicio" />
          </v-col>
          <v-col cols="4">
            <input-text label="ContaId" v-model="model.contaId" />
          </v-col>
          <v-col cols="4">
            <input-text label="CampanhaId" v-model="model.campanhaId" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <input-text label="NA" v-model="model.na" />
          </v-col>
          <v-col cols="4">
            <input-text label="NB" v-model="model.nb" />
          </v-col>
          <v-col cols="4">
            <input-text label="Resposta Opção" v-model="model.respostaOpcao" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-text label="Usuário" v-model="model.userTalk" required />
          </v-col>
          <v-col cols="6">
            <input-text
              label="Senha"
              type="password"
              required
              v-model="model.passTalk"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <input-textarea label="Mensagem" v-model="model.mensagem" />
          </v-col>
        </v-row>
      </template>
    </modal-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      model: {},
      ID: ''
    }
  },
  methods: {
    openModal (sender) {
      const th = this
      th.show = true
      th.model = {}
      if (sender) {
        console.log('sender', sender)
        th.model = sender
        console.log('model', th.model)
        th.ID = th.model.id
      } else th.ID = ''
      console.log(th.model)
    },
    submit () {
      const th = this
      th.$api.SmsTalkTelecom.Persist(th.model, th.model.id ? 'id' : '').then(
        function (response) {
          if (th.$api.UI.PostAction(response)) {
            th.show = false
            th.$emit('close', !response.error)
          }
        }
      )
    }
  }
}
</script>
